import { Ranking } from "./components/Ranking";

export default Ranking;
